import { HttpClient } from "@angular/common/http";
import { Injectable, OnInit } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Baseproperties } from "../../utility/baseproperties";
import { Router } from "@angular/router";

@Injectable({providedIn: 'root'})
export class SchedularLogService implements  OnInit{
  exceldownloadModal=false;
  items: any;
  tabIndexvalue=new BehaviorSubject<any>(0);

    baseproperties: Baseproperties = new Baseproperties();
private baseURL = this.baseproperties.gatewayBaseURL+'/common'; 
    constructor(private httpClient:HttpClient,private route:Router,private schedularlogservice:SchedularLogService){}
  ngOnInit(){
  }
  
    refreshfilter=new BehaviorSubject<any>('');
    filtersObservable=new BehaviorSubject<any>(''); 
    // product: string = "";
    // schedule: string = ""; 
    // status: string = "";
    // type: string = ""; 
    // from_date :any='';
    // to_date :any='';
    // page: number ;
    // size: number ;


  filterrefresh(){
    this.refreshfilter.next('refresh');
  }
  
  getFilterChange(filterdata){ 
    this.filtersObservable.next(filterdata)
  }

    // Get Product
    get_product(filterdata) : Observable<any>{
      return this.httpClient.post(`${this.baseURL}/schedularlog/getProduct`, filterdata);
    }
    // Get Schedule
    get_schedular(filterdata) : Observable<any>{
      return this.httpClient.post(`${this.baseURL}/schedularlog/getSchedule`, filterdata);
    }
    get_status(filterdata) : Observable<any>{
      return this.httpClient.post(`${this.baseURL}/schedularlog/getStatus`, filterdata);
    }
    // Get Schedule
    get_type(filterdata) : Observable<any>{
      return this.httpClient.post(`${this.baseURL}/schedularlog/getType`, filterdata);
    }
    // Get Filtered Tasks
    get_filtered_scheduler_data(payload: any) : Observable<any>{ 
      return this.httpClient.post(`${this.baseURL}/schedularlog/getFilteredSchedulerData`,payload);
  }
    schedulerlog_data_excel(payload){
      return this.httpClient.post(`${this.baseURL}/schedularlog/schedularlogDataExcel`,payload,{ responseType: 'blob' }); 
    }

  count_scheduler_data(filterdata): Observable<any> {    
    return this.httpClient.post(`${this.baseURL}/schedularlog/schedulerdatacount`, filterdata);
  }
  get_schedulerlog_table_data(filterdata): Observable<any> { 
    return this.httpClient.post(`${this.baseURL}/schedularlog/getSchedulerlogTableData`, filterdata);
  }

}